import type { FC } from "react";
import type { SvgIcons } from "../../type/Icons";

const CustomCloseIcon:FC<SvgIcons> = ({fill="#b3bec1",width="20px", height="20px"}) => {
  return (
    <>
        <svg className="icon" style={{fill:fill, width:width}} viewBox="0 0 32 32"><path d="M6.32321 9.23054L13.0927 16L6.32321 22.7694L9.23051 25.6767L15.9998 18.9074L22.7695 25.6771L25.6768 22.7698L18.9073 16.0004L25.6768 9.23095L22.7695 6.32365L16.0002 13.0929L9.23051 6.32324L6.32321 9.23054Z"></path></svg>
    </>
  )
}

export default CustomCloseIcon